export function useCategories( articles ) {

    let uncategorizedItems = []
    let categoriesObj = {}
    articles.forEach(item => {
        
        let category = item.articleVariation ? item.articleVariation.article.mainCategory : item.article.mainCategory
        if ( category == null ) {
            uncategorizedItems.push(item)
        }
        else {
            if ( categoriesObj[category.code]  === undefined ) {
                categoriesObj[category.code] = category
                categoriesObj[category.code].items = []
            }
            categoriesObj[category.code].items.push(item)
        }
    });

    let categories = Object.values(categoriesObj)
    if ( uncategorizedItems.length > 0 ) {
        categories.push({
            libelle: 'Autres',
            items: uncategorizedItems
        })
    }

    return categories

}